<template>
  <div class="col-md-6">
    <div class="" style="display:flex;">
      <div class="form-group" style="width:60%;">
        <custom-text :field="fields[0]" :value="fields[0].value" :field_idx="0" @field-updated="update">
        </custom-text>
      </div>
      <div class="" style="margin-right: 0;margin-left: auto;">
        <button class="btn btn-complete" @click="$emit('add')">Créer</button>
        <button class="btn btn-danger" @click="$emit('cancel')">Annuler</button>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
import CustomText from "components/Forms/Elements/Text"

import { mapState, mapGetters } from 'vuex'
  export default {

    props: ["value"],

    components:{
      CustomText
    },

    mounted () {
      $('.name').focus()
    },

    computed: {
      ...mapState([ 'formError' ]),
      ...mapGetters([ 'anyError' ]),
      fields() {
        let v = [
          {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:0, required:true, value:"", label:"Marques",type:"text"},
        ]
        return v
      }
    },

    methods:{
      update(event)
      {
        this.$emit('input', event.new_value)
      }
    }

  }
</script>

<style lang="scss" scoped>
  div {
    position: relative;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    li {
      line-height: 1.2rem;
    }
  }

  .name {
    font-size: 0.9rem;
  }

</style>



// WEBPACK FOOTER //
// client/components/Customer/Brands/NewItem.vue